import React, { createElement, useCallback, useRef, useState } from 'react';
import { useInput } from '@app/hooks/useInput';
import { StyledInputs, StyledTextInputProps } from '../styled/form/Inputs';
import { StyledForms } from '../styled/form/Form';
import { worksansoxford } from '@app/style';
import { normalize } from '@app/helpers';
import { theme } from '@app/theme';

interface CustomDateTimePickerProps extends StyledTextInputProps {
  name: string;
  label: string;
  mode?: 'date' | 'time' | 'datetime' | 'datetime-local';
}

export const DateHourPicker: React.FC<CustomDateTimePickerProps> = ({ name, label, mode = 'time', ...props }) => {
  const { field, error, formState } = useInput(name);

  return (
    <StyledInputs.Holder>
      <StyledInputs.Label isFilled isDirty={formState.isDirty} isBlurred={!formState.touchedFields}>
        {label}
      </StyledInputs.Label>

      {!!error && (
        <StyledForms.Error>
          <StyledForms.ErrorLabel>
            {error}
          </StyledForms.ErrorLabel>
        </StyledForms.Error>
      )}

      <input
        ref={field.ref}
        type={mode}
        value={field.value}
        // @ts-expect-error
        style={{
          height:
            props.size === "large" ? normalize(92) :
              props.size === "small" ? normalize(58) :
                normalize(76),
          ...worksansoxford,
          fontSize: normalize(21),
          fontWeight: '500',
          aspectRatio: props.round ? "1/1" : undefined,
          color: theme.colors.babypowder,
          textAlign: props.center ? 'center' : 'left',
          borderRadius: props.inside ? 0 : props.round ? 100 : 5,
          backgroundColor: props.size === "small" ? theme.colors.oxfordblue : 'rgba(240, 249 , 252, .04)',
          padding: props.nude ? 0 : props.size === "small" ? normalize(21) : normalize(34),
          border: 'none',
          outlineWidth: 0,
          borderBottomColor: props.nude ? 'transparent' : props.error ? theme.colors.crimson : props.isBlurred ? 'rgba(255,255,255,0)' : theme.colors.celadonblue,
          borderBottomWidth: props.nude ? 0 : 3,
          opacity: 1,
          width: '100%',
          zIndex: 999,
        }}
        {...props}
        onChange={(e) => field.onChange(e.target.value)}
      />
    </StyledInputs.Holder>
  );
};